import React, { FC } from 'react';
import EventCharts, { EventCharts as EventChartsInnerComponent } from '@components/machines/components/eventsChart';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { connect } from 'react-redux';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByProductionOrderId, productionOrdersSearch } from '@reducers/search';
import { getNCFilesByProductionOrderId } from '@reducers/manufacture';
import { ProductionOrderScreenProps } from '@v2/pages/productionOrder/common/interfaces';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';
import { loadSingleBatch } from '@reducers/batch';

interface ProductionOrderDetailsNCFilePerformanceProductiveProps extends ProductionOrderScreenProps {}

const ProductionOrderDetailsNCFilePerformanceProductiveComponent: FC<ProductionOrderDetailsNCFilePerformanceProductiveProps> = ({
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
  productionOrdersSearch,
}) => {
  const title = useTitle();

  useProductionOrderDetails({
      productionOrdersSearch,
      getNCFilesByProductionOrderId,
      getProductionBatchByProductionOrderId,
      loadSingleBatch,
      updateHeaderConfig,
      getAllNcFiles: true,
    });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <EventCharts getContentElement={(props) => <EventChartsInnerComponent {...props} />} />
    </DetailsPageWrapper>
  );
};

const ProductionOrderDetailsNCFilePerformanceProductive = connect(null, {
  productionOrdersSearch,
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
})(ProductionOrderDetailsNCFilePerformanceProductiveComponent);

export { ProductionOrderDetailsNCFilePerformanceProductive };
